import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// COMPONENTES
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Clientes from "./components/Clientes";
import Maquinas from "./components/Maquinas";
import CompanySettings from "./components/CompanySettings.jsx";
import Presupuestos from "./components/Presupuestos.jsx";
import SettingsHome from "./components/SettingsHome.jsx";
import PaymentPresets from "./components/PaymentPresets.jsx";
import Facturas from "./components/Facturas";
import ComprasList from "./components/compras/ComprasList";
import CompraForm from "./components/compras/CompraForm";
import CompraPagos from "./components/compras/CompraPagos";
import Documentos from "./components/Documentos";
import ChecklistInstalacionManager from "./components/ChecklistInstalacionManager";
import Correo from "./components/Correo";
import Bancos from "./components/Bancos";
import Usuarios from "./components/Usuarios.jsx";
import SatPage from "./components/tecnicos/SatPage";
import CRM from "./components/crm/CRM";
import AdjuntarVisita from "./components/presupuestos/AdjuntarVisita";





import Tecnicos from "./components/tecnicos/Tecnicos";
import EditorInforme from "./components/tecnicos/EditorInforme";


import DashboardPro from "./components/DashboardPro";
import ChecklistTemplates from "./components/tecnicos/ChecklistTemplates";

function App() {
  const [bootstrapped, setBootstrapped] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  // Autocarga de sesión
  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    if (token && userData) {
      setIsAuthenticated(true);
      try {
        setUser(JSON.parse(userData));
      } catch {}
    }
    setBootstrapped(true);
  }, []);

  if (!bootstrapped) return <div style={{ padding: 20 }}>Cargando…</div>;

  return (
    <Router>
      <div className="App">
        <Routes>

          {/* LOGIN */}
          <Route
            path="/login"
            element={
              !isAuthenticated ? (
                <Login
                  setIsAuthenticated={setIsAuthenticated}
                  setUser={setUser}
                />
              ) : (
                <Navigate to="/dashboard" />
              )
            }
          />

          {/* DASHBOARD */}
          <Route
            path="/dashboard"
            element={
              isAuthenticated ? (
                <Dashboard user={user} setIsAuthenticated={setIsAuthenticated} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          {/* DASHBOARD PRO (home) */}
          <Route
            path="/"
            element={
              isAuthenticated ? <DashboardPro /> : <Navigate to="/login" />
            }
          />

          <Route
  path="/crm"
  element={isAuthenticated ? <CRM /> : <Navigate to="/login" />}
/>


          {/* TÉCNICOS */}
          <Route
            path="/tecnicos"
            element={isAuthenticated ? <Tecnicos /> : <Navigate to="/login" />}
          />
          {/* SAT */}
<Route
  path="/sat/:instalacionId"
  element={isAuthenticated ? <SatPage /> : <Navigate to="/login" />}
/>


          {/* AJUSTES CHECKLISTS INSTALACIÓN */}
<Route
  path="/tecnicos/checklists"
  element={isAuthenticated ? <ChecklistTemplates /> : <Navigate to="/login" />}
/>

          <Route
            path="/tecnicos/informe/:id"
            element={isAuthenticated ? <EditorInforme /> : <Navigate to="/login" />}
          />

          <Route
  path="/presupuestos/:id/adjuntar-visita"
  element={<AdjuntarVisita />}
/>


          {/* USUARIOS */}
          <Route
            path="/ajustes/usuarios"
            element={isAuthenticated ? <Usuarios /> : <Navigate to="/login" />}
          />

          {/* BANCOS */}
          <Route path="/bancos" element={<Bancos />} />

          {/* FACTURAS */}
          <Route
            path="/facturas"
            element={isAuthenticated ? <Facturas /> : <Navigate to="/login" />}
          />

          {/* CLIENTES */}
          <Route
            path="/clientes"
            element={
              isAuthenticated ? <Clientes user={user} /> : <Navigate to="/login" />
            }
          />

          {/* MAQUINAS */}
          <Route
            path="/maquinas"
            element={
              isAuthenticated ? <Maquinas user={user} /> : <Navigate to="/login" />
            }
          />

          {/* AJUSTES HOME */}
          <Route
            path="/ajustes"
            element={isAuthenticated ? <SettingsHome /> : <Navigate to="/login" />}
          />

          {/* AJUSTES EMPRESA */}
          <Route
            path="/ajustes/empresa"
            element={
              isAuthenticated ? <CompanySettings user={user} /> : <Navigate to="/login" />
            }
          />

          {/* AJUSTES FORMAS DE PAGO */}
          <Route
            path="/ajustes/pagos"
            element={isAuthenticated ? <PaymentPresets /> : <Navigate to="/login" />}
          />

          {/* PRESUPUESTOS */}
          <Route
            path="/presupuestos"
            element={isAuthenticated ? <Presupuestos /> : <Navigate to="/login" />}
          />

          {/* COMPRAS */}
          <Route
            path="/compras"
            element={isAuthenticated ? <ComprasList /> : <Navigate to="/login" />}
          />

          <Route
            path="/compras/nueva"
            element={isAuthenticated ? <CompraForm /> : <Navigate to="/login" />}
          />

          <Route
            path="/compras/editar/:id"
            element={isAuthenticated ? <CompraForm /> : <Navigate to="/login" />}
          />

          <Route
            path="/compras/pagos/:id"
            element={isAuthenticated ? <CompraPagos /> : <Navigate to="/login" />}
          />

          {/* DOCUMENTOS */}
          <Route
            path="/documentos"
            element={isAuthenticated ? <Documentos /> : <Navigate to="/login" />}
          />

          {/* CHECKLIST */}
          <Route
            path="/documentos/checklist"
            element={
              isAuthenticated ? (
                <ChecklistInstalacionManager />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          {/* CORREO */}
          <Route
            path="/correo"
            element={isAuthenticated ? <Correo /> : <Navigate to="/login" />}
          />

          {/* 404 */}
          <Route
            path="*"
            element={<div style={{ padding: 20 }}>Ruta no encontrada</div>}
          />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
